//親要素のクリック伝播をキャンセルする
export const clickCancel = (
  e:
    | React.MouseEvent<HTMLDivElement, MouseEvent>
    | React.FocusEvent<HTMLInputElement, Element>
) => {
  e.preventDefault();
  e.stopPropagation();
};
